





























import { RouterNames } from "@/router/routernames";
import { alegaciones_lote } from "@/shared/dtos/alegaciones_lote";
import { MessageService } from "@/shared/services/message-service";
import alegaciones_loteModule from "@/store/modules/alegaciones_lote-module";
import { UtilsString } from "@/utils/utils-string";
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    DynamicTable: () => import("@/views/dynamic_tables/dynamic_table.vue"),
  },
})
export default class AlegacionesLista extends Vue {
  nuevo() {
    this.abrir_formulario("-1");
  }

  editar(obj: alegaciones_lote) {
    this.abrir_formulario(UtilsString.ValueOf(obj.id));
  }

  eliminar(obj: alegaciones_lote) {
    alegaciones_loteModule
      .eliminarLote(obj.id)
      .then(() => {
        //@ts-ignore
        this.$refs["data_table"].refresh();
      })
      .catch(() => {
        MessageService.toast(
          "No se ha podido eliminar, hay datos asociados a este rol de usuarios",
          MessageService.TypeWarning
        );
      });
  }

  abrir_formulario(id: string) {
    this.$router.push({
      name: RouterNames.alegacioneslotevisor,
      params: { id: id },
    });
  }
}
